
import {defaultLocale,localeOptions} from '../../constants/defaultValues'

import {
	CHANGE_LOCALE,
	CHANGE_STORE,
	CHANGE_FEATURE_TOGGLE,
	CHANGE_TENANT_INFO,
} from '../actions';

const getTenantInfoFromStorage = () => {
	try {
		const stored = localStorage.getItem('tenantInfo');
		return stored ? JSON.parse(stored) : null;
	} catch (error) {
		console.error('Error parsing tenantInfo from localStorage:', error);
		return null;
	}
};

const INIT_STATE = {
	locale: (localStorage.getItem('currentLanguage') && localeOptions.filter(x=>x.id===localStorage.getItem('currentLanguage')).length>0) ? localStorage.getItem('currentLanguage') : defaultLocale,
	tenantInfo: getTenantInfoFromStorage(),
};

const settingsReducer = (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_LOCALE:
		return { ...state, locale:action.payload};

		case CHANGE_STORE:
		return { ...state, store:action.payload};

		case CHANGE_FEATURE_TOGGLE:
		return { ...state, featureToggle:action.payload};

		case CHANGE_TENANT_INFO:
		return { ...state, tenantInfo:action.payload};

		default: return { ...state };
	}
};

export default settingsReducer;